/**
 * Hvem som har laget appen, og hvordan man kan si fra.
 *
 * ── Hvorfor dette er en fil og ikke tekst i en komponent ───────────────────
 *
 * Fordi det er *innstillinger*, ikke innhold. Navnet og profil-lenka er de to
 * eneste tingene her som er personlige, og de skal kunne endres uten å røre
 * markup — og uten å lete etter dem.
 *
 * ── Hva som med vilje IKKE står her ────────────────────────────────────────
 *
 * Ingen e-postadresse og intet telefonnummer. Det er et uttrykt krav, og det er
 * også grunnen til at kontaktkanalen er en profil man sender melding gjennom:
 * mottakeren når fram uten at adressen ligger på en offentlig side der den kan
 * høstes.
 *
 * En `mailto:` ville vært det enkleste og er derfor verdt å si nei til
 * eksplisitt: den *er* å publisere adressen, bare skrevet på en annen måte.
 */

/**
 * Navnet siden går under.
 *
 * Oversettes ikke: det er et navn, ikke en setning. Står her og ikke i
 * ordbøkene av samme grunn som `AUTHOR` — og fordi tre steder trenger det:
 * fanetittelen, `index.html` og sitemap-vokteren.
 */
export const SITE_NAME = "My Norway Trips";

/** Adressen siden bor på. Brukes til kanoniske lenker og sitemap. */
export const SITE_URL = "https://mynorwaytrips.com";

/**
 * Navnet som står på siden.
 *
 * Det samme som i LICENSE, så de to ikke kan komme i utakt.
 */
export const AUTHOR = "Sushant Srivastava";

/**
 * Profilen folk kan sende en melding gjennom — LinkedIn, Mastodon eller
 * liknende.
 *
 * Tom streng betyr «ingen kanal ennå», og da vises hele kontaktavsnittet
 * *ikke*. Det er med vilje: en knapp som lover «send meg en melding» og ikke
 * fører noe sted er verre enn ingen knapp, og det er samme regel resten av
 * appen følger for lenker den ikke kan stå inne for — se utils/placeLink.ts
 * og utils/rentalLink.ts.
 *
 * Sett inn hele URL-en, med https://. Ingenting annet trengs.
 *
 * Merk om etterprøving: LinkedIn svarer HTTP 999 på enhver automatisk
 * forespørsel, også mot profiler som finnes, så denne lenka kunne ikke prøves
 * slik `entur.no` og `autopass.no` ble det i TravelServices. 999 er ikke et
 * bevis på at lenka er død — det er LinkedIn som avviser roboter. Kilden er
 * her eieren selv, som er en bedre autoritet på sin egen profil enn et
 * statuskall uansett.
 */
export const CONTACT_PROFILE = "https://www.linkedin.com/in/sushant-srivastava-b72331219/";

/** Navnet på tjenesten profilen ligger på, vist på knappen. F.eks. «LinkedIn». */
export const CONTACT_LABEL = "LinkedIn";

/** Om kontaktavsnittet har noe å vise. Begge må stå for at knappen skal gi mening. */
export function hasContact(): boolean {
  return CONTACT_PROFILE.trim().length > 0 && CONTACT_LABEL.trim().length > 0;
}
